export default __webpack_public_path__ + "static/media/hostdog.5862f433.png";